<ng-container >
  <div class="funnel">
    <div class="row h-100">
      <div class="col-lg-5 col-12">
        <app-left-side></app-left-side>
      </div>
      <div class="col-lg-7 col-12 position-relative">
        <div class="right-side">
          <div class="content">
            <div class="title">
              <i class="fas fa-check-circle"></i>  მზადაა!
            </div>
            <small><i class="fas fa-info-circle me-2 mt-1"></i>შენ მიერ მითითებულ ელ. ფოსტაზე და ნომერზე მიიღებ სადაზღვევო პოლისს და დაზღვევის პირობებს
            </small>
            <div class="d-flex mt-5" >
              <a class="me-5" (click)="downloadPolicy()">
                <i class="fas fa-file-download me-2"></i>
                პოლისის ჩამოტვირთვა
              </a>
              <a href="https://aldagi.info/travelgeo" download target="_blank">
                <i class="fas fa-file-download me-2"></i>
                სადაზღვევო პირობები
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
